import {range} from './range';

export const rangeArray = (from: number, to: number): number[] => Array.from(range(from, to));
